import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 30 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsx("mask", {
        id: "m3bkcsdrl__mask0_9422_41453",
        style: {
          maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "30",
        height: "30",
        children: _jsx("path", {
          d: "M1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15Z",
          fill: "#C4C4C4",
          stroke: "#152361",
          strokeWidth: "2"
        })
      }), _jsxs("g", {
        mask: "url(#m3bkcsdrl__mask0_9422_41453)",
        children: [_jsx("path", {
          d: "M1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15Z",
          fill: "#DE2910",
          stroke: "#152361",
          strokeWidth: "2"
        }), _jsxs("g", {
          clipPath: "url(#f8qk19omx__clip0_9422_41453)",
          children: [_jsx("path", {
            d: "M48 2H2V32.6667H48V2Z",
            fill: "#DE2910"
          }), _jsx("path", {
            d: "M9.66808 5.06668L12.3719 13.3876L5.29297 8.24579H14.0432L6.9643 13.3876L9.66808 5.06668Z",
            fill: "#FFDE00"
          }), _jsx("path", {
            d: "M17.9323 3.65591L17.6767 6.55902L16.1741 4.05969L18.8574 5.19947L16.0156 5.85369L17.9323 3.65591Z",
            fill: "#FFDE00"
          }), _jsx("path", {
            d: "M21.497 7.06495L20.1323 9.64095L19.7183 6.75317L21.7474 8.84873L18.875 8.34784L21.497 7.06495Z",
            fill: "#FFDE00"
          }), _jsx("path", {
            d: "M21.8418 12.2069L19.5469 14.006L20.3494 11.2L21.3512 13.9396L18.9336 12.3091L21.8418 12.2069Z",
            fill: "#FFDE00"
          }), _jsx("path", {
            d: "M17.8742 14.3637L17.7414 17.277L16.1365 14.839L18.8658 15.8664L16.0547 16.6382L17.8742 14.3637Z",
            fill: "#FFDE00"
          })]
        }), _jsx("path", {
          d: "M1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15Z",
          stroke: "#152361",
          strokeWidth: "2"
        })]
      }), _jsx("defs", {
        children: _jsx("clipPath", {
          id: "f8qk19omx__clip0_9422_41453",
          children: _jsx("rect", {
            width: "46",
            height: "30.6667",
            fill: "white",
            transform: "translate(2 2)"
          })
        })
      })]
    }))
  });
};
export default Component;
